import { render, staticRenderFns } from "./ticket_related_types.vue?vue&type=template&id=38d95d8e&scoped=true&"
import script from "./ticket_related_types.vue?vue&type=script&lang=js&"
export * from "./ticket_related_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d95d8e",
  null
  
)

export default component.exports